import { CachedMap } from '@lexriver/cache'
import { Settings } from "../../Settings";
import { JsonProduct, isValidJsonProduct } from "../json-data-types/JsonProduct";

import { RequestMaker, EnumRequestPrefix, WebsocketJsonRequest } from "./RequestMaker";
import { DataTypes } from "@lexriver/data-types";
import { EnumProductSort } from '../enums/EnumProductSort';
import { EnumSortDirection } from '../enums/EnumSortDirection';
import { GlobalState } from '../GlobalState';

const filename = 'ServerProducts'

export module ServerProducts{

    export const jsonProductById = new Map<number, JsonProduct>() // global cache!
    export const jsonProductByUrl = new Map<string, JsonProduct>() // global cache

    export async function getProductPricesByProductIdAsync(productId:number, showZeroQuantityProducts:boolean){
        const [retailPrice, wholesalePrice] = await RequestMaker.sendWebsocketJsonRequestAsync<[number, number]>({query:'product-prices-by-id', params:{productId, showZeroQuantityProducts}}, filename)
        if(retailPrice>0){
            return [retailPrice, wholesalePrice]
        }
        return undefined
    }

    export function clearAllCache(){
        jsonProductById.clear()
        jsonProductByUrl.clear()
        cachedProductIdsByQuery.clearCache()
    }
    

    //#region product-by-id
    //const cachedProductById = new CachedMap<number, JsonProduct>(Settings.cacheAgeInMsForProducts, async (productId:number) => {
    export async function updateCachedProductByIdAsync(productId:number, showZeroQuantityProducts:boolean){
        const method = 'updateCachedProductAsync'
        const response = await RequestMaker.sendWebsocketJsonRequestAsync<JsonProduct>({query:'product-by-id', params:{productId, showZeroQuantityProducts}}, filename)
        //console.log('response=', response)
        if(isValidJsonProduct(response)){
            if(response.id !== productId){
                console.error(filename, method, 'Wrong data.id', response.id, productId)
                throw new Error()
            }
            //return data as JsonProduct
            //console.log('### setting', productId, response)
            jsonProductById.set(productId, response)
        } else {
            console.error(filename, method, 'response=', response, 'not a valid json product')
            throw new Error(filename+': cachedProductById seems like not a product!')
        }

    }

    export async function updateChachedProductByUrlAsync(productUrl:string, showZeroQuantityProducts:boolean){
        const methodName = 'updateChachedProductByUrlAsync'
        const response = await RequestMaker.sendWebsocketJsonRequestAsync<JsonProduct>({query:'product-by-url', params:{productUrl, showZeroQuantityProducts}}, filename)
        if(isValidJsonProduct(response)){
            if(response.url !== encodeURIComponent(productUrl)){
                console.error(filename, methodName, 'wrong product.url', response.url, productUrl)
                throw new Error(`${filename}:${methodName}`)
            }
            jsonProductByUrl.set(productUrl, response)
        } else {
            console.error(filename, methodName, 'response=', response, 'not a valid json product')
            throw new Error(`${filename}:${methodName}`)
        }
    }


    export async function getProductByIdOrUrlAsync(productIdOrUrl:string){
        const productId = Number(productIdOrUrl)
        if(productId){
            return await getProductByIdAsync(productId)
        }
        return await getProductByUrlAsync(productIdOrUrl)
    }

    export async function getProductByIdAsync(productId:number){
        const methodName = 'getProductByIdAsync'
        if(!productId) throw new Error(`${methodName}: no productId`)
        try {
            if(jsonProductById.has(productId)) return jsonProductById.get(productId)
            await updateCachedProductByIdAsync(productId, GlobalState.productShowZeroQuantityProductsO.get() ?? false)
            if(jsonProductById.has(productId) == false) {
                console.error(methodName, 'failed')
                return
            }
            return jsonProductById.get(productId)

        } catch(error){
            console.error(methodName, 'must return undefined', error)
            return undefined
        }
    }

    export async function getProductByUrlAsync(productUrl:string){
        const methodName = 'getProductByUrlAsync'
        if(!productUrl) throw new Error(`${methodName}: no productUrl`)
        try {
            if(jsonProductByUrl.has(productUrl)) {
                return jsonProductByUrl.get(productUrl)
            }
            await updateChachedProductByUrlAsync(productUrl, GlobalState.productShowZeroQuantityProductsO.get() ?? false)
            if(jsonProductByUrl.has(productUrl)) {
                return jsonProductByUrl.get(productUrl)
            }
            throw new Error(`product not found`)

        } catch(error){
            console.error(filename, methodName, error)
        }
        return undefined
    }




    export async function updateCachedProductsByProductIdsAndReturnAsync(productIds:number[], showZeroQuantityProducts: boolean){
        const methodName = 'updateCachedProductsAsync'
        const response = await RequestMaker.sendWebsocketJsonRequestAsync<JsonProduct[]>({
            query: 'products-by-ids-pack',
            params: {productIds, showZeroQuantityProducts}
        }, filename)

        let result: {[productId:number]:JsonProduct} = {}

        for(let product of response){
            if(!isValidJsonProduct(product)){
                console.error('not a valid json product', product)
                throw new Error(methodName+': not a valid json product')
            }
            jsonProductById.set(product.id,product)
            result[product.id] = product
        }

        return result
    }





    export async function getProductsByIdsAsync(productIds:number[], showZeroQuantityProducts:boolean){
        //if(productIds.length == 0) throw new Error('productIds.length == 0')
        if(productIds.length == 0) return {}
        return await updateCachedProductsByProductIdsAndReturnAsync(productIds, showZeroQuantityProducts)
    }

    //#endregion product-by-id

    export async function validateProductIds(productIds:number[], showZeroQuantityProducts:boolean){
        const result = await RequestMaker.sendWebsocketJsonRequestAsync<number[]>({query:'validate-product-ids', params:{productIds, showZeroQuantityProducts}}, filename)
        return result
    }


    //#region products-by-query
    const cachedProductIdsByQuery = new CachedMap<WebsocketJsonRequest, number[]>({
        maxAgeInMilliseconds: Settings.cacheAgeInMsForProducts, 
        useLazyUpdate: true, 
        updateFunction: async (query: WebsocketJsonRequest) => {
            const method = 'cachedProductIdsByQuery update'
            //console.log(method)
            //const data = await RequestMaker.getJsonAsync(query)
            //const data: any = await RequestMaker.sendWebsocketRouteRequestAsync(query, filename)
            try {
                const data = await RequestMaker.sendWebsocketJsonRequestAsync<JsonProduct[]>(query, filename)
                //TODO: possible empty?
                if (DataTypes.isArray(data)) {
                    const countOfBadItems = data.filter(x => isValidJsonProduct(x) == false).length
                    if (countOfBadItems == 0) {
                        let result: number[] = []
                        for (let item of data) {
                            let jsonProduct = item as JsonProduct
                            jsonProductById.set(jsonProduct.id, jsonProduct)
                            result.push(jsonProduct.id)
                        }
                        return result
                    }
                }
                console.error(filename, method, 'bad result', 'query=', query, 'data=', data)
            } catch (error){
                console.error('ServreProducts.cachedProductIdsByQuery failed:', error)

            }
            //throw new Error()

            return []
        }
    })


    export async function getProductsAsync2(p:{
        categoryId:number, 
        productType:string, 
        sortBy: EnumProductSort, 
        sortDirection: EnumSortDirection,
        pageNumber:number, 
        count:number,
        showZeroQuantityProducts:boolean
        showHiddenProducts:boolean
        productColor:string
        
    }):Promise<JsonProduct[]>{
        if(!p.categoryId) return []
        let idsArray = await cachedProductIdsByQuery.getAsync({query: 'products-by-category-pack', params:p})
        return convertArrayOfProductIdsToArrayOfProducts(idsArray)

    }

    
    function convertArrayOfProductIdsToArrayOfProducts(idsArray:number[]){
        let result:JsonProduct[] = []
        for(let id of idsArray){
            let jsonProduct = jsonProductById.get(id)
            if(jsonProduct) result.push(jsonProduct)
        }
        return result
    }

    export async function searchAsync2(p:{
        searchQuery:string, 
        productType?:string, 
        // sortBy: EnumProductSort, 
        // sortDirection: EnumSortDirection, 
        pageNumber:number, 
        count:number ,
        showZeroQuantityProducts:boolean,
        showHiddenProducts:boolean
        productColor:string
        
    }){
        //let query = `/products/search/${searchQuery}/${productType}/${sortBy}/${sortDirection}/${pageNumber}/${count}`
        //console.log('## ServerProducts.ts offset=', offset, 'count=', count)
        //console.log('ServerProducts.ts searchAsync() query=', query)
        //return await cachedProductsByQuery.getAsync(query)
        //let idsArray = await cachedProductIdsByQuery.getAsync(query)
        // console.log(filename, 'searchAsync', searchQuery)
        const products = await RequestMaker.sendWebsocketJsonRequestAsync<JsonProduct[]>({query:'products-search', params:p}, filename)
        //console.log('idsArray=', idsArray)
        //return convertArrayOfProductIdsToArrayOfProducts(idsArray)
        return products

    }
    //#endregion products-by-query

    export async function getProductsBestSellers(p:{
        sortBy: EnumProductSort,
        sortDirection: EnumSortDirection,
        pageNumber?:number,
        count?:number
        showZeroQuantityProducts:boolean,
        showHiddenProducts:boolean

    }):Promise<JsonProduct[]>{
        p.pageNumber = p.pageNumber ?? 1
        p.count = p.count ?? 10
        const products = await RequestMaker.sendWebsocketJsonRequestAsync<JsonProduct[]>({query:'products-best-sellers', params:p}, filename)
        return products
    }


    //#region count-by-query
    // const cachedCountByQuery = new CachedMap<string, number>(Settings.cacheAgeInMsForProducts, async (query:string) => {
    //     //const method = 'cachedCountByQuery'
    //     //const data = await RequestMaker.getJsonAsync(query)
    //     const data:any = await RequestMaker.sendWebsocketRouteRequestAsync(query)
    //     //console.log(filename, method, 'query=', query, 'data=', data) //TODO:remove this line
    //     // if(Data.isObject(data) && data.hasOwnProperty('result') && Data.isNumber(data['result'])){
    //     //     return data['result']
    //     // } 
    //     return data
        

    //     //console.error('unable to get query', query)
        
    // })

    export async function getProductCountAsync2(p:{
        categoryId:number, 
        productType?:string, 
        showZeroQuantityProducts?:boolean,
        showHiddenProducts:boolean,
        productColor:string
    }){
        if(!p.categoryId){
            console.warn('getProductsCountAsync2 no categoryId, so return 0')
            return 0
        }
        return await RequestMaker.sendWebsocketJsonRequestAsync<number>({query:'products-count', params:p}, filename)
    }

    export async function getSearchCountAsync2(p:{
        searchQuery:string, 
        productType?:string, 
        showZeroQuantityProducts?:boolean,
        showHiddenProducts:boolean,
        productColor:string
    }){
        return await RequestMaker.sendWebsocketJsonRequestAsync<number>({query:'products-search-count', params:p}, filename)
    }
    //#endregion count-by-query



    export function getProductTitle(product:JsonProduct){
        return product.seo?.title ?? Settings.formatProductName(product.name, false, false)
    }

    
    export async function getOldProductAsync(p:{productId:number, productUrl:string}){
        if(p.productId && Number(p.productId)){
            const result = await RequestMaker.sendWebsocketJsonRequestAsync<JsonProduct>({
                query:'product-by-id',
                params:{
                    productId:p.productId,
                    showZeroQuantityProducts:true,
                    searchOldProducts:true
                }
            }, filename)
            if(result){
                return result
            }
        } 
        return await RequestMaker.sendWebsocketJsonRequestAsync<JsonProduct>({
            query:'product-by-url',
            params:{
                productUrl:p.productUrl,
                showZeroQuantityProducts:true,
                searchOldProducts:true
            }
        }, filename)
    }

}